
import AppWarn from './errors/app-warns'
import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'

export async function getSurveyRule() {
  let surveyRule = ''
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/survey_rule`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    surveyRule = response?.data?.payload
  } catch (err) {
    throw new AppWarn({name: 'Get survey rule', message:`Error while fetching survey rules. ${err.message}`})
  }
  return surveyRule
}
